class ManageInvitesListController {
  constructor($ngRedux, $filter, manageInvitesRepository, gettextCatalog) {
    'ngInject';
    this.filter = $filter;
    this.manageInvitesRepository = manageInvitesRepository;
    this.gettextCatalog = gettextCatalog;
    this.currentPage = 1;
    this.itemsPerPage = 10;
    this.maxSize = 1;
    this.loading = true;
    this.predicate = 'sent.at';
    this.reverse = true;
    this.invites;
    this.errorFlag = false;
    this.errorText = '';
    this.onLoadErrorFlag = false;
    this.onLoadErrorText = '';
    this.searchString = '';
    this.previousSearchString = '';
    this.filteredInvites = [];
  }

  $onInit() {
    this.getInvites();
  }

  orderInvites(predicate) {
    if (predicate === this.predicate) {
      this.reverse = !this.reverse;
    } else {
      this.reverse = false;
    }
    this.predicate = predicate;
    this.GTM_ListChanges('invitesOrderChanged');
  }

  pageChanged() {
    this.GTM_ListChanges('invitesPageChanged');
  }

  applyFilter(initialLoad) {
    if (
      !this.invites ||
      (typeof initialLoad === 'undefined' && this.previousSearchString === this.searchString)
    )
      return;
    this.filteredInvites = this.filter('filter')(this.invites, this.searchString);
    this.previousSearchString = this.searchString;
    this.GTM_ListChanges(initialLoad ? 'invitesLoaded' : 'invitesFiltered');
  }

  getInvites() {
    this.manageInvitesRepository.getAllInvites().then(
      (invites) => {
        this.invites = invites.data;
        this.applyFilter(true);
        this.loading = false;
      },
      (error) => {
        let errorMsg = this.gettextCatalog.getString(
          'An error occurred while retrieving invite information',
        );
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg =
              error.data.message +
              ' ' +
              (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += this.gettextCatalog.getString('. Please try again later.');
        }
        this.onLoadErrorText = errorMsg;
        this.onLoadErrorFlag = true;
        this.loading = false;
      },
    );
  }

  GTM_ListChanges(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: this.invites.length,
        totalFiltered: this.filteredInvites.length,
        pageNumber: this.currentPage,
        orderBy: this.predicate,
        sortDirection: this.reverse ? 'descending' : 'ascending',
      },
    });
  }
}

export const ManageInvitesListComponent = {
  template: require('./list.html'),
  bindings: {},
  controller: ManageInvitesListController,
  controllerAs: 'vm',
};
